import React, { useContext, useEffect, useState } from 'react'
import { useTranslation, Trans } from 'react-i18next'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'

import appConfig from 'app.config'

import { BoxInfo, CircleSpinner } from 'shared/index'

import SspContext from 'selfServicePortal/contexts/SspContext'
import sddService from 'selfServicePortal/services/CreditCardServices/sddService'

interface IProps {
	show: boolean
	handleClose: Function
}

export const SDDDisableModal = ({ show, handleClose }: IProps) => {
	const { customerData, setSddRefreshData } = useContext(SspContext)
	const { t } = useTranslation()
	const [success, setSuccess] = useState<boolean>(false)
	const [error, setError] = useState<boolean>(false)
	const [loading, setLoading] = useState<boolean>(false)
	const [partyId, setPartyId] = useState<string>()

	useEffect(() => {
		setPartyId(customerData?.customerId)
	}, [customerData])

	async function disableSddMandate() {
		setLoading(true)
		if (partyId !== undefined) {
			try {
				await sddService
					.disableMandate({ partyId })
					.then((response) => {
						if (response.status === 200) {
							setSuccess(true)
						} else {
							setError(true)
						}
					})
					.finally(() => setLoading(false))
			} catch (error) {
				setError(true)
				console.warn(error)
				setLoading(false)
			}
		}
	}

	return (
		<>
			<Modal
				className={`${appConfig.country} sdd-disable-mandate-modal`}
				show={show}
				onHide={() => {
					if (error) {
						setError(false)
					}
					handleClose()
					setSddRefreshData(true)
				}}
				backdrop="static"
				keyboard={false}>
				<Modal.Header closeButton>
					<Modal.Title>{t('SDDDisable')}</Modal.Title>
				</Modal.Header>
				{loading ? (
					<Modal.Body>
						<CircleSpinner />
					</Modal.Body>
				) : (
					<>
						{success ? (
							<>
								<Modal.Body>
									<BoxInfo
										css={'success'}
										message={t('SDDDisableSuccess')}
									/>
								</Modal.Body>

								<Modal.Footer>
									<Button
										variant="primary"
										onClick={() => {
											handleClose()
											setSddRefreshData(true)
										}}>
										{t('Close')}
									</Button>
								</Modal.Footer>
							</>
						) : (
							<>
								<Modal.Body>
									<Trans t={t} i18nKey="SDDDisableText">
										Are you sure you want to disable SDD?
										<br />
										<br />
										You can always re-register if you wish.
										<br />
										<br />
										Still want to disable?
									</Trans>
									{error ? (
										<BoxInfo
											css={'fail'}
											message={t('ErrorMsg')}
										/>
									) : (
										<></>
									)}
								</Modal.Body>

								<Modal.Footer>
									<Button
										variant="danger"
										className="btn-outline"
										onClick={() => disableSddMandate()}>
										{t('SDDDisable')}
									</Button>
									<Button
										variant="primary"
										onClick={() => {
											if (error) {
												setError(false)
											}
											handleClose()
										}}>
										{t('Cancel')}
									</Button>
								</Modal.Footer>
							</>
						)}
					</>
				)}
			</Modal>
		</>
	)
}
